import { render, staticRenderFns } from "./trendyolinfo.vue?vue&type=template&id=68819721&scoped=true"
import script from "./trendyolinfo.ts?vue&type=script&lang=js&external"
export * from "./trendyolinfo.ts?vue&type=script&lang=js&external"
import style0 from "./trendyolinfo.vue?vue&type=style&index=0&id=68819721&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68819721",
  null
  
)

export default component.exports